import React from "react"

import { useState } from "react"

import { extractFields } from "../../../../../../utils/form/extractFields"
import { checkRequireLabel } from "../../../../../../utils/form/checkRequireLabel"
import { useTranslations } from "@dfb/gatsby-dfb-theme/src/hooks/useTranslations"

import MDefaultform from "../m_defaultForm"
import DfbCheckbox from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_checkbox"
import DfbHeadline from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline"
import DfbInput from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input"
import DfbInputTextarea from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input_textarea"
import DfbParagraph from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_paragraph"
import { emailRegex } from "../../../../../../utils/form/emailRegex"

const MFanConcerns = ({ data }) => {
  const t = useTranslations()
  const formType = data.form_definition[0].identifier
  const fields = extractFields(data?.form_definition?.[0]?.form_field)

  const [chairmanMail, setChairmanMail] = useState("")

  return (
    <MDefaultform
      buttonLabel="Absenden"
      postUrl={process.env.FORM_API_URL}
      disableCaptcha={data.form_definition[0].captcha === 0}
      identifier={data.form_recipient[0].identifier}
      DOImail={chairmanMail}
      formType={formType}
    >
      {({ register, errors }) => (
        <>
          {data.headline && (
            <DfbHeadline
              headline={data.headline}
              headline_level="h3"
              add_class="m-Formblock-headline"
            />
          )}

          {data.text && (
            <DfbParagraph add_class="m-Formblock-text" text={data.text} />
          )}

          {data.headline && (
            <DfbHeadline
              headline={t("form.chairman")}
              headline_level="h4"
              add_class="m-Formblock-headline"
            />
          )}

          {(fields.chairmanfirstname || fields.chairmanlastname) && (
            <div className="m-Formblock-row-third">
              {[fields.chairmanfirstname, fields.chairmanlastname]
                .filter(Boolean)
                .map((formItem, index) => (
                  <div className="m-Formblock-row-third-cell" key={index}>
                    <DfbInput
                      {...register(formItem.identifier, {
                        required: formItem.required
                          ? t("form.errorMessage.input")
                          : false,
                      })}
                      error={errors[formItem.identifier]}
                      errorMessage={errors?.[formItem.identifier]?.message}
                      label={`${formItem.label}${formItem.required === 1 ? "*" : ""}`}
                      focused
                    />
                  </div>
                ))}
              <div className="m-Formblock-row-third-cell">
                <DfbInput
                  {...register(fields.chairmanemail.identifier, {
                    required:
                      fields.chairmanemail.required === 1
                        ? t("form.errorMessage.input")
                        : false,
                    pattern: {
                      value: emailRegex,
                      message: t("form.errorMessage.emailPattern"),
                    },
                    onChange: e => {
                      setChairmanMail(e.target.value)
                    },
                  })}
                  error={errors[fields.chairmanemail.identifier]}
                  errorMessage={
                    errors?.[fields.chairmanemail.identifier]?.message
                  }
                  label={`${fields.chairmanemail.label}${fields.chairmanemail.required === 1 ? "*" : ""}`}
                  focused
                />
              </div>
            </div>
          )}

          {fields.checkboxFanClubcodex && (
            <div className="m-Formblock-checkbox">
              <DfbCheckbox
                text={t("form.fanConcerns.clubCodexText")}
                {...register(fields.checkboxFanClubcodex.identifier, {
                  required: true,
                })}
                error={errors[fields.checkboxFanClubcodex.identifier]}
              />
            </div>
          )}

          {fields.consentdataprocessing && (
            <div className="m-Formblock-checkbox">
              <DfbCheckbox
                text={t("form.fanConcerns.dataProcessingText")}
                {...register(fields.consentdataprocessing.identifier, {
                  required: true,
                })}
                error={errors[fields.consentdataprocessing.identifier]}
              />
            </div>
          )}

          {data.headline && (
            <DfbHeadline
              headline={t("form.deputy")}
              headline_level="h4"
              add_class="m-Formblock-headline"
            />
          )}

          {(fields.deputyfirstname ||
            fields.deputylastname ||
            fields.deputyemail) && (
            <div className="m-Formblock-row-third">
              {[
                fields.deputyfirstname,
                fields.deputylastname,
                fields.deputyemail,
              ]
                .filter(Boolean)
                .map((formItem, index) => (
                  <div className="m-Formblock-row-third-cell" key={index}>
                    <DfbInput
                      {...register(formItem.identifier, {
                        required: formItem.required
                          ? t("form.errorMessage.input")
                          : false,
                        pattern:
                          formItem.identifier === fields.deputyemail?.identifier
                            ? {
                                value: emailRegex,
                                message: t("form.errorMessage.emailPattern"),
                              }
                            : undefined,
                      })}
                      error={errors[formItem.identifier]}
                      errorMessage={errors?.[formItem.identifier]?.message}
                      label={`${formItem.label}${formItem.required === 1 ? "*" : ""}`}
                      focused
                    />
                  </div>
                ))}
            </div>
          )}

          {fields.deputyfanclubname && (
            <div className="m-Formblock-input">
              <DfbInput
                {...register(fields.deputyfanclubname.identifier, {
                  required:
                    fields.deputyfanclubname.required === 1
                      ? t("form.errorMessage.input")
                      : false,
                })}
                error={errors[fields.deputyfanclubname.identifier]}
                errorMessage={
                  errors?.[fields.deputyfanclubname.identifier]?.message
                }
                label={`${fields.deputyfanclubname.label}${fields.deputyfanclubname.required === 1 ? "*" : ""}`}
                focused
              />
            </div>
          )}

          {fields.deputyfanclubdescription && (
            <div className="m-Formblock-input">
              <DfbInputTextarea
                {...register(fields.deputyfanclubdescription.identifier, {
                  required:
                    fields.deputyfanclubdescription.required === 1
                      ? t("form.errorMessage.input")
                      : false,
                })}
                label={`${fields.deputyfanclubdescription.label}${fields.deputyfanclubdescription.required === 1 ? "*" : ""}`}
                error={errors[fields.deputyfanclubdescription.identifier]}
                errorMessage={
                  errors?.[fields.deputyfanclubdescription.identifier]?.message
                }
              />
            </div>
          )}

          {(fields.deputyfoundingdate || fields.deputynumberofmembers) && (
            <div className="m-Formblock-input-half">
              {[fields.deputyfoundingdate, fields.deputynumberofmembers]
                .filter(Boolean)
                .map(formItem => (
                  <div className="m-Formblock-input" key={formItem.label}>
                    <DfbInput
                      {...register(formItem.identifier, {
                        required: formItem.required
                          ? t("form.errorMessage.input")
                          : false,
                      })}
                      error={errors[formItem.identifier]}
                      errorMessage={errors?.[formItem.identifier]?.message}
                      label={`${formItem.label}${formItem.required === 1 ? "*" : ""}`}
                      focused
                    />
                  </div>
                ))}
            </div>
          )}

          {fields.deputyhometown && (
            <div className="m-Formblock-input-half">
              <div className="m-Formblock-input">
                <DfbInput
                  {...register(fields.deputyhometown.identifier, {
                    required: fields.deputyhometown.required
                      ? t("form.errorMessage.input")
                      : false,
                  })}
                  error={errors[fields.deputyhometown.identifier]}
                  errorMessage={
                    errors?.[fields.deputyhometown.identifier]?.message
                  }
                  label={checkRequireLabel(fields.deputyhometown)}
                  focused
                />
              </div>
              <div className="m-Formblock-input"></div>
            </div>
          )}

          <div className="m-Formblock-checkbox">
            <DfbParagraph text={t("form.privacyText")} />
          </div>
        </>
      )}
    </MDefaultform>
  )
}

export default MFanConcerns
